module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAWCAYAAAD9091gAAAAAXNSR0IArs4c6QAAAOpJREFUKFPt0r1KA1EQxfH/ue5WKVLYCVpojCB+FFaKVhZiFRDsU6QQBRF9ALGxUrPLaieIir3PIPgGFoKltbXgR45sJEsSbe287fyG4Z4Z0ffs/dDk5jCglZh4Vd1120qZaEDryIiIgcUekLmy/oEyQSlvFNF8AU5dXX7H5wIb7sBrgXihDVKPzRldAoMibJrWkqHRBoknR+Dt2mgWwu4Ojxcp48cFuPJM6YXX24Dvt3k6kOTElZMC5CPOPDW8pYfnzo9+gP4s/sF3In+cQ35VCdWmcD1AreeiOjvJPDr9SbRRZmjvV9C9vC9EQ3PjjNm+igAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/data_up_arrow.png
// module id = 2Kq8
// module chunks = 1